'use client';

import { useEffect } from 'react';
import { useUserData } from '@/contexts/LoginContext';
import { useRouter } from '@/hooks/useRouter';
import { SupportPage } from '../components/shared/SupportForm/SupportPage';
import { useSearchParams } from 'next/navigation';

export default function Page() {
  const userData = useUserData();
  const router = useRouter();
  const searchParams = useSearchParams();
  const productIdForReport = searchParams?.get('product_id_for_report') ?? undefined;

  useEffect(() => {
    if (!userData) {
      return;
    }

    const params = new URLSearchParams();
    if (productIdForReport) {
      params.set('product_id_for_report', productIdForReport);
    }

    const query = params.toString();
    router.replace(`/my/support${query ? `?${query}` : ''}`);
  }, [userData, router, productIdForReport]);

  return <SupportPage productIdForReport={productIdForReport} />;
}
